import React, { useEffect, useState } from 'react';
import AdminNavbar from '../Navbar/AdminNavbar'
import { CButton, Loading } from '../../Components'
import { Form, FormGroup } from "react-bootstrap";
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { validateAddMembershipPlanForm, validateDefaultUser } from './Validators';
import { planTypes } from '../../../Config/Constant';
import { AdminCreateMembershipPlan, getAdminPlans } from '../Services/Plans';
import { useNavigate } from 'react-router-dom';
import { urlPrefix } from '../../Helpers/Common';
import { adminCreateDefaulter, getAdminUsers } from '../Services/User';

const AddDefaulter = () => {
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();

    const getInitialPageData = async () => {
        setLoading(true)
        let result = await getAdminUsers({ remove_limit_offset: true, without_defaulters:true });
        if (result?.success) {
            setUsers(result.data);
        } else {
            navigate(urlPrefix() + "/admin/defaulters/")
        }
        setLoading(false)
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            user_id: "",
            note: ""
        },
        validate: validateDefaultUser,
        onSubmit: async (values, { resetForm }) => {
            setLoading(true)
            let result = await adminCreateDefaulter(values);
            result?.success ? toast.success(result.message) : toast.error(result?.error?.message)
            navigate(urlPrefix() + "/admin/defaulters")
            setLoading(false)
        }
    });

    const errorElement = (msg) => {
        return <div className='small text-danger'>{msg}</div>
    }

    const handleMultiSelect = (e, formikKey, check) => {
        const value = JSON.parse(e.target.value);
        //Run this code when ready for multi select
        // const exist = find(formik.values[formikKey] , (item) => item[check] === value[check])
        // if(!exist){
        //   formik.setFieldValue('publishers', [...formik.values.publishers,value]);
        // }
        //For now just do this
        formik.setFieldValue(formikKey, [value]);
    }

    useEffect(() => {
        getInitialPageData()
    }, [])


    return (
        <div className="admin-panel-main">
            <div className="panel-row">
                <div className="left">
                    <AdminNavbar></AdminNavbar>
                </div>
                <div className="right">

                    <div className="add-book">
                        <div className="panel-title-top">
                            <div className="top-left">
                                <button className='top-back-12' onClick={() => navigate(urlPrefix() + "/admin/defaulters/")}>Back</button>
                                <h3 className="heading-h3">Add Defaulter</h3>
                            </div>
                            <div className="top-right">
                                <div className="right-side">
                                    {/* <CButton label="Add Book" custClassName="login-button t-btn"></CButton> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="add-book-form">
                        <Form className="book-panel-form" onSubmit={formik.handleSubmit}>
                            <div className="pan-form-row">
                                <div className="cost-form-input">
                                    <FormGroup className="cost-form-group">
                                        <Form.Label>User:</Form.Label>
                                        <Form.Select
                                            aria-label="Default select example"
                                            name="user_id"
                                            onChange={(e) => { formik.setFieldValue("user_id", e.target.value) }}
                                            onBlur={formik.handleBlur}
                                        >   
                                            <option value={null}>Please select user</option>
                                            {
                                                users.map((item) => <option value={item.user_id}>{item.first_name} {item.last_name}</option>)
                                            }
                                        </Form.Select>
                                        {formik.errors.plan_id ? errorElement(formik.errors.plan_id) : null}
                                    </FormGroup>
                                </div>

                                <div className="cost-form-input">
                                    <FormGroup className="cost-form-group">
                                        <Form.Label>Note:</Form.Label>
                                        <input
                                            id="note"
                                            name="note"
                                            type="note"
                                            onChange={formik.handleChange}
                                            value={formik.values.note}
                                            placeholder=""
                                            className="form-control"
                                            autoComplete="new-password"
                                        />
                                        {formik.errors.note ? errorElement(formik.errors.note) : null}
                                    </FormGroup>
                                </div>

                            </div>
                            <div className="submit-cta">
                                <CButton label="Submit" type="submit" custClassName="login-button t-btn"></CButton>
                            </div>

                        </Form>
                    </div>

                </div>
            </div>
            {
                loading ? <Loading /> : null
            }
        </div>
    )
}

export default AddDefaulter